var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#EF3340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V113.994H0V-0.00585938Z",
    fill: "#00B5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 227.994H513V341.994H0V227.994Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6 212.594C242.6 212.594 224 193.994 224 170.994C224 147.994 242.6 129.394 265.6 129.394C272.8 129.394 279.5 131.194 285.4 134.394C276.2 125.394 263.5 119.794 249.6 119.794C221.3 119.794 198.4 142.694 198.4 170.994C198.4 199.294 221.3 222.194 249.6 222.194C263.5 222.194 276.2 216.594 285.4 207.594C279.5 210.794 272.8 212.594 265.6 212.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.6 142.194L303.1 157.694L318 150.594L310.9 165.494L326.4 170.994L310.9 176.494L318 191.394L303.1 184.294L297.6 199.794L292.1 184.294L277.2 191.394L284.3 176.494L268.8 170.994L284.3 165.494L277.2 150.594L292.1 157.694L297.6 142.194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAz);
export default __webpack_public_path__ + "static/media/AZ.1b72e54fdc2f6cb06d11c73f364a7c3f.svg";
export { ForwardRef as ReactComponent };